export default __webpack_public_path__ + "static/7-levels-of-stack@2x-810e929dcaf48672f3dcbac9cc7ae82d.png";